import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import HomeService from "../../Service/HomeService";


const initialState = {
    featureData: [],
    loading: false,
    error: ""
}

export const getFeature = createAsyncThunk('feature/getFeature', async () => {
    const result = await HomeService.viewFeature();
    if (result) {
        console.log("FeatureDatasRes", result);
        return result;
    }
})

const featureSlice = createSlice({
    name: "fetchFeature",
    initialState: initialState,
    reducers: {},
    extraReducers: {
        [getFeature.pending]: (state) => {
            state.loading = true;
        },
        [getFeature.fulfilled]: (state, { payload }) => {
            if (payload.status) {
                state.featureData = payload.data;
                state.ThemeCatFeatureData = payload.photography;
                state.loading = false;
            } else {
                state.themeticData = [];
                state.loading = false;
            }
        },
        [getFeature.rejected]: (state) => {
            state.loading = false;
            state.error = "Eror"
        }
    }
})

export const featureReducer = featureSlice.reducer;